import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {ImageItemModel} from "@cybfed/models/image-item.model";
import {appConstants} from "@cybfed/constants";
import {CommonModule, NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {PrimaryButtonComponent} from "@cybfed/shared/components/primary-button/primary-button.component";
import {SecondaryButtonComponent} from "@cybfed/shared/components/secondary-button/secondary-button.component";
import {MaskLoaderPrivateComponent} from "@cybfed/shared/components/mask-loader-private/mask-loader-private.component";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {FileUploadService} from "@cybfed/core/services/file-upload.service";
import {
  FileUploaderComponent
} from "@cybfed/ui-lib/forms/image-input/media-gallery/file-uploader/file-uploader.component";
import {MediaStore} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.store";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {EventManagerService} from "@cybfed/core/services/event-manager.service";
import {UserStore} from "@cybfed/core/store/user.store";

@Component({
  selector: 'app-media-lib',
  templateUrl: './media.component.html',
  styleUrl: './media.component.scss',
  standalone: true,
  imports: [
    NgClass,
    NgForOf,
    TranslateModule,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    MaskLoaderPrivateComponent,
    NgIf,
    FileUploaderComponent,
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [PopupHelperService, FileUploadService]
})
export class MediaComponent implements OnInit, AfterViewInit {
  @ViewChild('modal') modal: any;
  @ViewChild('horizontalScrollWrapper') scrollWrapper:any;
  @ViewChild('sizes') sizesBlock: any;
  @ViewChild('mosaicImagesComponent') mosaicImagesComponent: any;
  @ViewChild('cropper') cropper: any;

  @Input() multiplayer: any;
  @Input() modalOptions: any;
  @Input() fileUploaderSize: boolean = true;
  @Input() requiredTitle: boolean = false;
  @Output() getImages = new EventEmitter();

  @Input() textareaRows = 2;

  bannerSizes: any = appConstants.IMAGESIZES

  // @Input() multiplayer = Boolean;

  imageSizes: any;
  selectedSize: any;
  selectedItem: any;
  showCropperBlock: boolean = false;

  showAiBlock: boolean = false;
  aiPrompt: string = '';


  showLoader: boolean = false;
  imagesList: Array<ImageItemModel> = [];


  selectedItemsIndexArr: Array<string> =[];
  selectedImages: Array<ImageItemModel> =[];

  fileTitle: string = '';
  hasError: boolean = false;
  next: string = '';
  filterObject: any;
  errorMessage: any
  formats = []
  constructor(private fileUploadService: FileUploadService,
              private popupHelperService: PopupHelperService,
              private eventManagerService: EventManagerService,
              private userStore: UserStore,
              public mediaStore: MediaStore) {
    effect(() => {
      if(this.mediaStore.showMediaLib){
        this.openModal()
      }
    });
    this.mediaStore.onCreate = this.onCreate.bind(this);
    this.mediaStore.getVideoSource = this.getVideoSource.bind(this);
    effect(() => {
        this.selectedSize = this.mediaStore.size;
        let needRender = false;
        if(this.formats !== this.mediaStore.formats){
          needRender = true;
        }
        this.formats = this.mediaStore.formats
        this.filterObject={...this.filterObject, class: this.selectedSize?.class, type: this.selectedSize?.type, next: this.next, formats: this.formats };
        if(needRender && this.mediaStore.showMediaLib){
          this.filterObject={...this.filterObject, class: this.selectedSize?.class, type: this.selectedSize?.type, next: null, formats: this.formats };
          this.getList();
        }
    });
  }

  ngOnInit(): void {
    this.imageSizes = appConstants.IMAGESIZES
    if(!this.modalOptions){
      this.modalOptions = {
        size:  <any>"lg",
        centered: true,
        scrollable: true,
        modalDialogClass: 'user-images',
        backdropClass: '',
        backdrop: 'static',
        windowClass: 'custom-class'
      }
    }

    if(this.mediaStore.size){
      this.selectedSize = this.mediaStore
    }else {
      this.selectedSize = null;
    }
    this.filterObject = {...this.filterObject, class: this.selectedSize?.class,  type: this.selectedSize?.type,next: this.next}

  }

  ngAfterViewInit(): void {
    const n = this.scrollWrapper?.nativeElement?.children.length;
    let totalWidth = 0
    appConstants.IMAGESIZES.map(item => {
      totalWidth += Number(item.width)
    })
    this.scrollWrapper?.nativeElement?.style.setProperty('--total', String(totalWidth));
  }

  getImageSource(dataImg: any): void {
    this.onCreate(dataImg);
  }

  getVideoSource(file: any, makeAutoEmit: boolean = false){
    const newData  = {
      fileName: file.name,
      fileType: file.type
    }
    this.fileUploadService.generatePreSigned(newData).subscribe((res: any) => {
      if(!res.hasError){
        this.uploadVideoToS3(file, res.data.url, makeAutoEmit)
      }
    })
  }

  uploadVideoToS3(file: File, presignedUrl: string, makeAutoEmit: boolean = false): void {
    this.mediaStore.uploadingProcess = true
     // Show progress bar
    const xhr = new XMLHttpRequest();

    // Event listener for upload progress
    xhr.upload.addEventListener('progress', (event: ProgressEvent) => {
      if (event.lengthComputable) {
        const progress = (event.loaded / event.total) * 100;
        this.mediaStore.progressVideoUpload = progress; // Update progress value
      }
    });

    // Upload the file
    xhr.open('PUT', presignedUrl, true);
    xhr.setRequestHeader('Content-Type', file.type);

    xhr.onload = () => {
      if (xhr.status === 200) {
        const s3Url = presignedUrl.split('?')[0]; // Extract the final S3 URL
        let mediaData = {
          s3Url: s3Url,
          title: this.fileTitle,
          type: 'video',
          className: 'original'
        };
        this.fileUploadService.createMedia(mediaData).subscribe((res: any) => {
          const { file } = res.data;
          this.mediaStore.uploadingProcess = false
          this.imagesList.unshift(file);
          if(makeAutoEmit){
            this.mediaStore.setImageResource( [file]);
          }
        });
      } else {
        this.mediaStore.uploadingProcess = false
        console.error('Error uploading video to S3');
      }
    };

    xhr.onerror = (error) => {
      console.error('Error uploading video:', error);
    };

    // Send the file data to S3
    xhr.send(file);
  }



  onChange(e: any): void {
    this.fileTitle = e.target.value;
  }

  onCreate(dataImg: string | File, makeAutoEmit: boolean = false): void {
    if (this.requiredTitle && (!this.fileTitle || this.fileTitle === '')) {
      this.hasError = true
    } else {
      this.mediaStore.uploadingProcess = true
      this.showLoader = true;
      this.hasError = false;
      if(dataImg instanceof File){
        const formData = new FormData();
        formData.append('file', dataImg, dataImg.name);
        formData.append('title', this.fileTitle || dataImg.name);
        formData.append('class', this.selectedSize?.class || dataImg.name);
        this.fileUploadService.uploadFile(formData).subscribe((res: any) => {
          if (!res.hasError) {
            this.mediaStore.uploadingProcess = false
            const {file} = res.data;
            this.imagesList.unshift(file);
            this.showLoader = false;
            this.cropper.showCropper = false;
            this.showCropperBlock = false;
            if(makeAutoEmit){
              this.mediaStore.setImageResource( [file]);
            }
          }
        });
      }else {
        const newData = {
          file: dataImg,
          title: this.fileTitle,
          class: this.selectedSize.class,
        }
        this.fileUploadService.createFile(newData).subscribe((res: any) => {
          this.mediaStore.uploadingProcess = false
          if (!res.hasError) {
            const {file} = res.data;
            this.imagesList.unshift(file);
            this.showLoader = false;
            this.cropper.showCropper = false;
            this.showCropperBlock = false;
            if(makeAutoEmit){
              this.mediaStore.setImageResource( [file]);
            }
          }
        });
      }

    }
  }

  getList(loadMore = false): void {
    this.showLoader = true;
    if(this.userStore.currentUser){
      this.fileUploadService.getFilesList(this.filterObject).subscribe((res: any) => {
        if (!res.hasError) {
          this.showLoader = false;
          if(loadMore){
            this.imagesList = this.imagesList.concat(res.data.data);
          }else{
            this.imagesList =res.data.data;
          }
          this.next = res.data.next;
        }
        this.showLoader = false;
      });
    }

  }



  openModal(): void {
    this.selectedImages = []
    if(this.imagesList.length<1){
      this.getList()
    }
  }

  showCropperBlockFunc(isShow: boolean): void {
    this.fileTitle = '';
    this.showCropperBlock = isShow;
  }

  setSizeForFilter(data: any): void {
    this.filterObject = {...this.filterObject, class: data.class, type: data.type,next: null}
    this.getList();
    this.selectedSize = data;
  }

  setAll(): void {
    this.filterObject={...this.filterObject,class: null, type: null, next: null}
    this.selectedSize = null;
    this.getList();
  }

  setSizeForCropper(data: any): void {
    this.selectedSize = data;
  }


  loadMore(): void {
    this.filterObject={...this.filterObject,next: this.next}
    this.getList(true)
  }

  // before remove item open popup
  openPopup(item: ImageItemModel): void {
    const popupSettings = {
      customClass: {
        container:"z-index-9999",
        popup: "bg-000 w-15",
        confirmButton: "pink-button-imp",
        htmlContainer: "color-white",
      },
      icon: 'question',
      text: 'Are You sure ?',
      confirmButtonText: 'Yes',
    }
    this.popupHelperService.printQuestion(popupSettings, item.id, this.onDelete, this)
  }


  onDelete(id: string): void {
    // get selected item index from
    const index = this.mosaicImagesComponent.selectedItemIndex;
    const indexOfArr = this.mosaicImagesComponent.selectedItemsIndexArr.indexOf(index);

    this.fileUploadService.delete(id).subscribe((res: any) => {
      if (!res.hasError) {
        this.imagesList = this.imagesList.filter((item) => item.id !== id);
        this.mosaicImagesComponent.selectedItemsIndexArr.splice(indexOfArr, 1);
        this.mosaicImagesComponent.selectedImages.splice(indexOfArr, 1);
      }
    })
  }


  onSetImages(): void {
    this.errorMessage = null;
    if(this.selectedImages.length === 0){
      this.errorMessage = 'chose_image_required'
      return
    }
    if(this.mediaStore.setImageResource){
      this.mediaStore.setImageResource(this.selectedImages);
    }
    this.mediaStore.showMediaLib = false;
    this.mediaStore.setImageResource = null;
  }

  onClose(){
    this.mediaStore.showMediaLib = false;
    this.mediaStore.setImageResource = null;
  }

  selectItem(index:string, item: ImageItemModel):void{
    const indexOfArr = this.selectedItemsIndexArr.indexOf(index);
    if (indexOfArr > -1) {
      this.selectedItemsIndexArr.splice(indexOfArr, 1);
      this.selectedImages.splice(indexOfArr, 1);
    }else{
      if(this.multiplayer){
        this.selectedItemsIndexArr.push(index)
        this.selectedImages.push(item)
      } else {
        this.selectedItemsIndexArr = [index]
        this.selectedImages = [item]
      }
    }
  }

  openNewImage(){
    if(!this.selectedSize){
      this.selectedSize = this.imageSizes[0];
    }
    this.cropper.clickOnFileElement()
  }

  openNewImageWithAi(){
    this.showAiBlock = true;
    this.aiPrompt = '';
  }

  startImageGeneration(){
    this.showAiBlock = true;
    this.aiPrompt = '';
  }
  onInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    const lineBreaks = (textarea.value.match(/\n/g) || []).length + 1;
    const lines = Math.floor(textarea.scrollHeight / 24); // Approximate line height
    this.textareaRows = Math.min(Math.max(lineBreaks, lines), 5);
  }

  getSpinnerColor(progress: number): string {
    if (progress < 50) {
      return 'linear-gradient(90deg, red ' + progress + '%, transparent ' + progress + '%)';
    } else {
      return 'linear-gradient(90deg, green ' + (progress - 50) + '%, transparent ' + (progress - 50) + '%)';
    }
  }

  doubleClickItem(event: MouseEvent, item: ImageItemModel) {
    event.preventDefault();
    if (this.mediaStore.selectOnDoubleClick) {
      event.stopPropagation()
      if(this.mediaStore.setImageResource){
        this.mediaStore.setImageResource( [item]);
      }
      this.mediaStore.showMediaLib = false;
      this.mediaStore.setImageResource = null;
    }
  }


  isDragging = false;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  async onDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      await this.handleFileUpload(files[0]);
    }
  }

  async handleFileUpload(file: any): Promise<any> {
    this.eventManagerService.handleOnDropFileUpload(file)
  }

}
